// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dashboard-view{flex:1}.dashboard-view .dashboard-inner{flex:1}", "",{"version":3,"sources":["webpack://src/views/analytics/dashboard.scss"],"names":[],"mappings":"AAAA,gBACE,MAAA,CACA,iCACE,MAAA","sourcesContent":[".dashboard-view {\n  flex: 1;\n  .dashboard-inner {\n    flex: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
